import React, { useMemo } from "react";
import PropTypes from "prop-types";
import PublicationLinks from "../../../../components/Publications/components/PublicationLinks";
import helpers from "../../../../common/utils/utils";
import { colorsForListElements, renderReviewStars } from "./helpers";
import ClinvarButton from "../../../clinvar-submissions/ClinvarButton";

const InformationTable = ({ item }) => {
  const publicationIds = useMemo(() => {
    const pubs = item?.pub_med_references || [];
    return [...pubs].sort((a, b) => b - a);
  }, [item?.pub_med_references]);

  if (item && Object.keys(item || {}).length) {
    return (
      <div className="varsome-inner-container" data-testid="clinvar-info-table">
        <table className="tw-w-full tw-ml-1">
          <thead>
            <tr>
              <th
                className="tw-w-2/12 tw-font-semibold tw-mb-0"
                data-testid="clinvar-clinical-significance"
              >
                Clinical Significance
              </th>
              <th
                className="tw-w-1/12 tw-font-semibold tw-mb-0"
                data-testid="clinvar-type"
              >
                Type
              </th>
              <th
                className="tw-w-3/12 tw-font-semibold tw-mb-0"
                data-testid="clinvar-review-status"
              >
                Review Status
                <span>&nbsp;&nbsp;</span>
                <span
                  className="tw-whitespace-nowrap"
                  data-testid="clinvar-review-stars"
                >
                  ({renderReviewStars(item)})
                </span>
              </th>
              <th
                className="tw-w-2/12 tw-font-semibold tw-mb-0"
                data-testid="clinvar-evaluation"
              >
                Last Evaluation
              </th>
              <th
                className="tw-w-2/12 tw-font-semibold tw-mb-0"
                data-testid="clinvar-num-submitters"
              >
                Number of Submitters
              </th>
              <th
                className="tw-w-2/12 tw-mb-0"
                data-testid="info-table-clinvar-button"
              >
                {" "}
                <ClinvarButton
                  type="primary"
                  analyticsLocation="Clinvar component"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                className="tw-w-2/12 tw-font-bold"
                data-testid="table-clinical-significance"
              >
                {colorsForListElements(item.clinical_significance)}
              </td>
              <td
                className="tw-w-1/12 tw-align-top"
                data-testid="table-clinvar-type"
              >
                {item.variant_type}
              </td>
              <td
                className="tw-w-3/12 tw-align-top"
                data-testid="table-review-status"
              >
                {item.review_status}
              </td>
              <td
                className="tw-w-2/12 tw-align-top"
                data-testid="table-evaluation"
              >
                {helpers.parseNumericDate(item.last_evaluation)}
              </td>
              <td
                className="tw-w-2/12 tw-align-top"
                data-testid="table-num-submitters"
              >
                {item.num_submitters}
              </td>
              <td className="tw-w-2/12" />
            </tr>
          </tbody>
        </table>
        <br />
        <table className="tw-w-full tw-ml-1">
          <thead>
            <tr>
              <th
                className="tw-w-1/5 tw-font-semibold tw-mb-0"
                data-testid="clinvar-publications"
              >
                Publications
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tw-w-2/5" data-testid="table-publications">
                {publicationIds.length ? (
                  <PublicationLinks ids={publicationIds} />
                ) : (
                  "Not found"
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
  return null;
};

InformationTable.propTypes = {
  item: PropTypes.shape({
    approval_date: PropTypes.string,
    disease: PropTypes.string,
    evidence_met: PropTypes.arrayOf(PropTypes.string),
    evidence_not_met: PropTypes.arrayOf(PropTypes.string),
    expert_panel: PropTypes.string,
    guideline: PropTypes.string,
    mode_of_inheritance: PropTypes.string,
    mondo_id: PropTypes.string,
    pathogenicity: PropTypes.string,
    pub_med_references: PropTypes.arrayOf(PropTypes.number),
    published_date: PropTypes.string,
    repo_link: PropTypes.string,
    retracted: PropTypes.string,
    summary: PropTypes.string,
    version: PropTypes.string,
    num_submitters: PropTypes.number,
    variant_type: PropTypes.string,
    review_status: PropTypes.string,
    last_evaluation: PropTypes.string,
    clinical_significance: PropTypes.arrayOf(PropTypes.string),
  }),
};

InformationTable.defaultProps = {
  item: {},
};

export default InformationTable;
